import { useIsSandboxAccount } from "@/services/auth/useIsSandboxAccount";

/**
 * Whether the active account can use the note taker: its settings and
 * inviting it to meetings. A sandbox's note taker never joins real meetings.
 */
export const useIsNoteTakerAvailable = (): boolean => !useIsSandboxAccount();
